import { PurchaseOrderActions } from '../actions/purchase-order.actions';
import { createReducer, on } from '@ordersnproducts/utils/create-reducer';
import { Action } from '@ngrx/store';

export interface MOOPurchaseOrderState {
  validMasks: string[];
  required: boolean;
}

const initialState: MOOPurchaseOrderState = {
  validMasks: [],
  required: false,
};

export const purchaseOrderReducer = createReducer(
  initialState,

  on(PurchaseOrderActions.isMandatory, (state, { validationRequired }) => {
    return {
      ...state,
      required: validationRequired,
    };
  }),
  on(PurchaseOrderActions.setValidMasks, (state, { payload }) => {
    return {
      ...state,
      validMasks: payload,
    };
  }),
);

export function reducer(state: MOOPurchaseOrderState | undefined, action: Action) {
  return purchaseOrderReducer(state, action);
}
